

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import RideBookingForm from './pages/RideBookingForm';
// import AdminDashboard from './pages/AdminDashboard.js';
// import Login from './pages/authentication/Login.js';
// import Signup from './pages/authentication/Signup.js';
// import ForgotPassword from './pages/authentication/ForgotPassword.js';
// import Dashboard from './pages/Dashboard';
// import AboutUs from './pages/privacy/AboutUs.js';
// import TermsAndConditions from './pages/privacy/TermsAndConditions.js';
// import PrivacyPolicy from './pages/privacy/PrivacyPolicy.js';
// import RazorpayPayment from './pages/payment/RazorpayPayment';
// import UserDashboard from './pages/UserDashBoard.js';
// import RideBooking from './pages/userRide/RideBooking.js';
// import NoInternet from './components/NoInternet';
// import { AuthProvider } from './components/AuthContext';
// import DataDeletionPage from './pages/privacy/DataDeletionPage.js';
// import SessionManager from "./components/SessionManager";
// import ResetPasswordWithOtp from './pages/authentication/ResetPasswordWithOtp';
// import PrivateRoute from './components/PrivateRoute'; // ✅ NEW
// import VendorAssignmentTest from "./pages/admin/VendorAssignmentTest";
// import VendorRecords from "./pages/vendor/VendorRecords";
// import HealthLogDashboard from './pages/health/HealthLogDashboard';
// import KpiDashboard from './pages/admin/KpiDashboard';

// function App() {
//   const [online, setOnline] = useState(navigator.onLine);

//   useEffect(() => {
//     const goOnline = () => setOnline(true);
//     const goOffline = () => setOnline(false);

//     window.addEventListener('online', goOnline);
//     window.addEventListener('offline', goOffline);

//     return () => {
//       window.removeEventListener('online', goOnline);
//       window.removeEventListener('offline', goOffline);
//     };
//   }, []);

//   if (!online) {
//     return <NoInternet />;
//   }

//   return (
//     <AuthProvider>
//        <Router>
//       <SessionManager>
       
//           <Routes>

//             {/* ✅ Public Routes */}
//             <Route path="/" element={<Login />} />
//             <Route path="/signup" element={<Signup />} />
//             <Route path="/forgot-password" element={<ForgotPassword />} />
//             <Route path="/reset-password-with-otp" element={<ResetPasswordWithOtp />} />
//             <Route path="/about" element={<AboutUs />} />
//             <Route path="/terms-condition" element={<TermsAndConditions />} />
//             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//             <Route path="/data-deletion" element={<DataDeletionPage />} />
//              <Route path="/payment" element={<RazorpayPayment />}/>
//              <Route path="/health-log" element={<HealthLogDashboard />}/>

//             {/* ✅ Protected Routes */}
//             <Route
//               path="/dashboard"
//               element={
//                 <PrivateRoute>
//                   <Dashboard />
//                 </PrivateRoute>
//               }
//             />
//             <Route
//               path="/admin-dashboard"
//               element={
//                 <PrivateRoute>
//                   <AdminDashboard />
//                 </PrivateRoute>
//               }
//             />
//             <Route
//               path="/user-dashboard"
//               element={
//                 <PrivateRoute>
//                   <UserDashboard />
//                 </PrivateRoute>
//               }
//             />
//             <Route
//               path="/book-ride"
//               element={
//                 <PrivateRoute>
//                   <RideBooking />
//                 </PrivateRoute>
//               }
//             />
          
// <Route 
//   path="/admin/vendor-test" 
//   element={<PrivateRoute><VendorAssignmentTest /></PrivateRoute>} 
// />
// <Route 
//   path="/admin/vendors" 
//   element={<PrivateRoute><VendorRecords /></PrivateRoute>} 
// />

// <Route
//   path="/admin/kpi"
//   element={
//     <PrivateRoute>
//       <KpiDashboard />
//     </PrivateRoute>
//   }
// />

//           </Routes>
        
//       </SessionManager>
//       </Router>
//     </AuthProvider>
//   );
// }

// export default App;
// //


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LandingPage from './pages/LandingPage';          // ← NEW
import RideBookingForm from './pages/RideBookingForm';
import AdminDashboard from './pages/AdminDashboard.js';
import Login from './pages/authentication/Login.js';
import Signup from './pages/authentication/Signup.js';
import ForgotPassword from './pages/authentication/ForgotPassword.js';
import Dashboard from './pages/Dashboard';
import AboutUs from './pages/privacy/AboutUs.js';
import TermsAndConditions from './pages/privacy/TermsAndConditions.js';
import PrivacyPolicy from './pages/privacy/PrivacyPolicy.js';
import RazorpayPayment from './pages/payment/RazorpayPayment';
import UserDashboard from './pages/UserDashBoard.js';
import RideBooking from './pages/userRide/RideBooking.js';
import NoInternet from './components/NoInternet';
import { AuthProvider } from './components/AuthContext';
import DataDeletionPage from './pages/privacy/DataDeletionPage.js';
import SessionManager from "./components/SessionManager";
import ResetPasswordWithOtp from './pages/authentication/ResetPasswordWithOtp';
import PrivateRoute from './components/PrivateRoute';
import VendorAssignmentTest from "./pages/admin/VendorAssignmentTest";
import VendorRecords from "./pages/vendor/VendorRecords";
import HealthLogDashboard from './pages/health/HealthLogDashboard';
import KpiDashboard from './pages/admin/KpiDashboard';

function App() {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (!online) {
    return <NoInternet />;
  }

  return (
    <AuthProvider>
      <Router>
        <SessionManager>
          <Routes>

            {/* ── Public Routes ── */}
            <Route path="/"        element={<LandingPage />} />   {/* ← landing page */}
            <Route path="/login"   element={<Login />} />          {/* ← login moved here */}
            <Route path="/signup"  element={<Signup />} />
            <Route path="/forgot-password"        element={<ForgotPassword />} />
            <Route path="/reset-password-with-otp" element={<ResetPasswordWithOtp />} />
            <Route path="/about"           element={<AboutUs />} />
            <Route path="/terms-condition" element={<TermsAndConditions />} />
            <Route path="/privacy-policy"  element={<PrivacyPolicy />} />
            <Route path="/data-deletion"   element={<DataDeletionPage />} />
            <Route path="/payment"         element={<RazorpayPayment />} />
            <Route path="/health-log"      element={<HealthLogDashboard />} />

            {/* ── Protected Routes ── */}
            <Route path="/dashboard"       element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/admin-dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
            <Route path="/user-dashboard"  element={<PrivateRoute><UserDashboard /></PrivateRoute>} />
            <Route path="/book-ride"       element={<PrivateRoute><RideBooking /></PrivateRoute>} />
            <Route path="/admin/vendor-test" element={<PrivateRoute><VendorAssignmentTest /></PrivateRoute>} />
            <Route path="/admin/vendors"     element={<PrivateRoute><VendorRecords /></PrivateRoute>} />
            <Route path="/admin/kpi"         element={<PrivateRoute><KpiDashboard /></PrivateRoute>} />

          </Routes>
        </SessionManager>
      </Router>
    </AuthProvider>
  );
}

export default App;

